<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       :viewBox="viewBox"
       :aria-labelledby="iconName"
  >
    <title :id="iconName" lang="en">{{iconName}}</title>
    <defs>
      <path d="M8,0 C12.431891,0 16,3.56810897 16,8 C16,12.431891 12.431891,16 8,16 C3.56810897,16 0,12.431891 0,8 C0,3.56810897 3.56810897,0 8,0 Z M8,1.5 C11.6009115,1.5 14.5,4.39908854 14.5,8 C14.5,11.6009115 11.6009115,14.5 8,14.5 C4.39908854,14.5 1.5,11.6009115 1.5,8 C1.5,4.39908854 4.39908854,1.5 8,1.5 Z M9.03150008,5.09398696 L3.5,10.6248691 L3.5,12.5 L5.37534042,12.5 L10.9068405,6.96911787 L9.03150008,5.09398696 Z M11.1873874,3.64063482 C10.9998534,3.45312173 10.6715431,3.45312173 10.484009,3.64063482 L10.484009,3.64063482 L9.56996914,4.55457262 L11.4453096,6.42970354 L12.3593495,5.51576573 C12.5468835,5.32825264 12.5468835,4.99997905 12.3593495,4.81246596 L12.3593495,4.81246596 Z" id="inactive-path-1"></path>
    </defs>
    <g id="inactive-V2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="inactive-Tax-Forms---1040" transform="translate(-64.000000, -422.000000)">
        <g id="inactive-.-Navigation/Stepper/Vertical/Sample" transform="translate(40.000000, 88.000000)">
          <g id="inactive-Input-Tax-Data" transform="translate(0.000000, 280.000000)">
            <g id="inactive-Icon" transform="translate(24.000000, 54.000000)">
              <mask id="inactive-mask-2" fill="white">
                <use xlink:href="#inactive-path-1"></use>
              </mask>
              <g id="inactive-Icon/feedback-attention"></g>
              <rect id="inactive-Icon-Color" fill-opacity="0.6" fill="#000000" mask="url(#inactive-mask-2)" x="0" y="0" width="16" height="16"></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    viewBox: { type: String, default: '0 0 24 24'},
    iconName: { type: String, default: ''},
    width: { type: [Number, String], default: 18 },
    height: {type: [Number, String], default: 18 },
    iconColor: {type: String, default: 'currentColor'}
  }
}
</script>
